import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const StatusFilter = ({
  selectedFilters,
  onFilterChange,
  statusFilters,
}: {
  selectedFilters: string[];
  onFilterChange: (filters: string[]) => void;
  statusFilters: { text: string; value: string }[];
}) => {
  const { t } = useTranslation();
  const filters = statusFilters;

  const [tempSelection, setTempSelection] = useState<string | null>(selectedFilters[0] || null);

  // Update tempSelection when selectedFilters prop changes
  useEffect(() => {
    setTempSelection(selectedFilters[0] || null);
  }, [selectedFilters]);

  const handleReset = () => {
    onFilterChange([]);
    setTempSelection(null);
  };

  return (
    <div className="p-2 bg-white border border-gray-300 rounded-md shadow-lg z-50">
      {filters.map((filter) => (
        <label key={filter.value} className="flex items-center space-x-2 p-2 hover:bg-gray-100 cursor-pointer">
          <input
            type="radio"
            name="status-filter"
            checked={tempSelection === filter.value}
            onChange={() => setTempSelection(filter.value)}
            className="h-4 w-4 text-blue-500 border-gray-300 focus:ring focus:ring-blue-200"
          />
          <span>{filter.text}</span>
        </label>
      ))}

      <div className="flex justify-between pt-2 border-t">
        <button className="text-sm px-2 py-1 text-primary-600 hover:text-primary-200" onClick={handleReset}>
          {t('status.button.reset')}
        </button>

        <button
          className="text-sm px-2 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
          onClick={() => onFilterChange(tempSelection ? [tempSelection] : [])}
        >
          {t('status.button.apply')}
        </button>
      </div>
    </div>
  );
};

export default StatusFilter;
